/**
 * PostHog Analytics Events for Initial Review Feature
 */

export const INITIAL_REVIEW_EVENTS = {
  BANNER_CTA_CLICKED: 'initial_review_banner_cta_clicked',
  TASK_PANEL_CTA_CLICKED: 'initial_review_task_panel_cta_clicked',
  REVIEW_COMPLETED: 'initial_review_completed',
} as const;

export const INITIAL_REVIEW_PROPERTIES = {
  MATTER_ID: 'matter_id',
  TASK_ID: 'task_id',
  CALL_PREP_ITEM_COUNT: 'call_prep_item_count',
  CAN_CONTACT_CLIENT: 'can_contact_client',
  TIME_TO_COMPLETE_SECONDS: 'time_to_complete_seconds',
} as const;
